import React, { useState } from 'react'
import { View, Button, RadioInput, Modal } from '@/components'
import { Channel } from 'stream-chat'
import { Chat, textVariant, theme } from '@/config'
import { createStyles } from '@codeleap/styles'
import { PropsOf } from '@codeleap/types'
import { getChatMuteOptions } from '@packages/chat'

type ChatMuteActionModalProps = PropsOf<typeof Modal> & {
  channel: Channel
}

const muteOptions = getChatMuteOptions()

export const ChatMuteActionModal = (props: ChatMuteActionModalProps) => {
  const { channel, ...modalProps } = props
  const [selectedValue, setSelectedValue] = useState<number | string>(8 * 60)

  const handleMute = () => {
    if (!selectedValue) return

    const muteTime: number = typeof selectedValue === 'string' ? parseInt(selectedValue) : selectedValue
    Chat.Services.toggleMuteChat(channel, muteTime)
    props?.toggle?.()
  }

  return (
    <Modal
      title='Mute notifications'
      style={['center', 'box:noPadding', {
        titleWrapper: styles.titleWrapper,
        box: styles.modalBox,
      }]}
      showClose
      {...modalProps}
    >
      <View
        style={styles.content}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <RadioInput
          debugName='ChatMuteActionModal:Radio'
          label=''
          value={selectedValue}
          onValueChange={(value) => {
            setSelectedValue(value)
          }}
          options={muteOptions}
          style={['options:vertical', {
            optionWrapper: styles.radioOption,
            optionLabel: styles.radioLabel,
            optionIndicator: styles.radioIndicator,
            'optionIndicator:selected': styles.radioIndicatorSelected,
            optionIndicatorInner: styles.radioIndicatorInner,
          }]}
        />

        <View style={['row', 'gap:2', 'fullWidth', { marginTop: theme.spacing.value(.8) }]}>
          <Button
            debugName='ChatMuteActionModal:Cancel'
            text='Cancel'
            onPress={props?.toggle}
            style={['small', 'neutralSecondary', 'flex', { wrapper: styles.buttonWrapper }]}
          />
          <Button
            debugName='ChatMuteActionModal:Confirm'
            text='Mute'
            onPress={handleMute}
            style={['small', 'flex', 'default', { wrapper: styles.buttonWrapper }]}
          />
        </View>

      </View>
    </Modal>
  )
}

const styles = createStyles((theme) => ({
  modalBox: {
    maxWidth: 453,
    width: '100%',
  },
  titleWrapper: {
    ...theme.spacing.padding(2),
  },
  content: {
    ...theme.presets.column,
    ...theme.spacing.paddingHorizontal(2),
    ...theme.spacing.paddingBottom(2),
    width: '100%',
  },
  buttonWrapper: {
    borderRadius: theme.radius.regular,
    height: theme.size.largeish,
    minHeight: theme.size.largeish,
  },
  radioOption: {
    ...theme.presets.row,
    ...theme.presets.alignCenter,
    ...theme.presets.justifySpaceBetween,
    width: '100%',
    cursor: 'pointer',
  },
  radioLabel: {
    ...theme.spacing.marginLeft(0),
    ...theme.spacing.marginRight(0),
    flex: 1,
    order: 1,
    ...textVariant('p3'),
    color: theme.colors.textHeadingHighlighted,
    fontWeight: 500,
  },
  radioIndicator: {
    order: 2,
    ...theme.spacing.marginLeft(2),
    width: 20,
    height: 20,
  },
  radioIndicatorSelected: {
    backgroundColor: theme.baseColors.primarySolid500,
    ...theme.border({
      color: theme.baseColors.primarySolid500,
      width: 1,
    }),
  },
  radioIndicatorInner: {
    height: theme.size.small,
    width: theme.size.small,
  },
}))

